import type { IContainer } from '../interface/container';
import binderMiddleware from './middleware/binder';
import binderReducer from './reducer/binder';
import binderStores from './store/binder';
import binderRenderer from './render/binder';

async function binder(container: IContainer): Promise<void> {
    binderMiddleware(container);
    binderReducer(container);
    binderStores(container);
    binderRenderer(container);
}

export default binder;
